import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { createAppSlice, type AppSlice } from "./slices/AppSlice";
import { createMeetSlice, type MeetSlice } from "./slices/MeetSlice";

export type AppStore = AppSlice & MeetSlice;

export const useAppStore = create<AppStore>()(
  devtools(
    persist(
      (...args) => ({
        ...createAppSlice(...args),
        ...createMeetSlice(...args),
      }),
      {
        name: "meet-storage",

        partialize: (state) => ({
          language: state.language,
          userInfo: state.userInfo,
          userProfile: state.userProfile,
          theme: state.theme,
        }),

        version: 1,

        migrate: (persistedState: any, version: number) => {
          if (version === 0) {
            return {
              ...persistedState,
            };
          }

          return persistedState as AppStore;
        },
      }
    ),
    {
      name: "MeetStore",
      enabled: true,
    }
  )
);
